import { useState, useEffect, useCallback } from 'react';
import { API_BASE } from '../utils/apiEndpoints';

export const FAUNDER_PURCHASE_LIMIT = 2000;

export function formatFaunderPurchased(template: string, count: number | null, limit: number): string {
  return template
    .replace('{count}', count == null ? '—' : String(count))
    .replace('{limit}', String(limit));
}

export function useFaunderStats() {
  const [purchasedCount, setPurchasedCount] = useState<number | null>(null);
  const [purchaseLimit, setPurchaseLimit] = useState(FAUNDER_PURCHASE_LIMIT);
  const [alreadyPurchased, setAlreadyPurchased] = useState(false);
  const [soldOut, setSoldOut] = useState(false);

  const refetch = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/subscription/faunder`, {
        credentials: 'include',
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || typeof data.purchasedCount !== 'number') {
        setPurchasedCount(null);
        return;
      }
      const limit = typeof data.purchaseLimit === 'number' ? data.purchaseLimit : FAUNDER_PURCHASE_LIMIT;
      setPurchasedCount(data.purchasedCount);
      setPurchaseLimit(limit);
      setAlreadyPurchased(Boolean(data.alreadyPurchased));
      setSoldOut(Boolean(data.soldOut) || data.purchasedCount >= limit);
    } catch {
      setPurchasedCount(null);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { purchasedCount, purchaseLimit, alreadyPurchased, soldOut, refetch };
}
